///<amd-module name="Core/Medius.Core.Web/Scripts/Medius/components/generic/presenter" />

import { create as createGenericModel } from "Core/Medius.Core.Web/Scripts/Medius/components/generic/model";

export function create(bindingParameters: any, viewModel: any){
    const presenter = createGenericModel(bindingParameters, viewModel);
    presenter.Template = ["display", presenter.Component].join("-");
    return presenter;
}